import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

// The lesson view loads in its own chunk with its messages and the scene renderer (spec 034), so
// the initial JS stays as it is.
const LessonPage = lazy(() => import('../components/lesson/LessonPage.js'))

export const Route = createFileRoute('/learn/$lesson')({
  component: function Learn() {
    const { lesson } = Route.useParams()
    return (
      <Suspense fallback={null}>
        <LessonPage lesson={lesson} />
      </Suspense>
    )
  },
})
